import React, { useState, useEffect } from "react";
import { Col, Container, Row, Alert } from "reactstrap";
import Section from "./Section";
import Pagination from "./Pagination";
import CustomCarousel from "./CustomCarousel";
import { FaSearch } from "react-icons/fa";

import sailfish from "../../assets/images/fish_types/sailfish.png";
import yellowFinTuna from "../../assets/images/fish_types/yellowfin_tuna.png";
import swordFish from "../../assets/images/fish_types/sword_fish.png";
import bigEyeTuna from "../../assets/images/fish_types/big_eye_tuna.png";
import blackMarlin from "../../assets/images/fish_types/blackmarlin.png";
import AllFish from "../../assets/images/fish_types/all2.png";

import Topbar from "./Topbar";
import StockListPage from "./StockListPage.js";
import { getStock } from "../../api/stock/getStockApi.js";
import { Icon } from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import { mdiWifiOff } from "@mdi/js";
import { InfinitySpin } from "react-loader-spinner";

const Stocks = () => {
  document.title = "Star Market | Stock";
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  const [filters, setFilters] = useState({
    Boat_Number: "",
    Product_Name: "",
    Quality_Grade: "",
    Harbour: "",
    minPrice: "",
    maxPrice: "",
    minWeight: "",
    maxWeight: "",
  });

  //console.log('searchQuery:', searchQuery);

  const [stockData, setStockData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const fetchStockData = async () => {
    setLoading(true);
    try {
      const response = await getStock();

      const data = response.data.data;
      console.log("Stock Data3:", data);
      setStockData(data); // Set the stock data
      setFilteredData(data); // Initialize filtered data with all stock data
    } catch (error) {
      console.error("Error fetching stock data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStockData(); // Fetch stock data when the component mounts
  }, []);

  // Filter stock data based on filters
  const filterStockData = () => {
    setLoading(true);
    let filtered = [...stockData]; // Make a copy of stockData

    console.log("Filters:", filtered);

    // Apply filters
    if (filters.Boat_Number) {
      filtered = filtered.filter((item) =>
        item.Boat_Number.includes(filters.Boat_Number)
      );
    }

    if (filters.Product_Name && filters.Product_Name !== "All") {
      filtered = filtered.filter((item) =>
        item.Product_Name.includes(filters.Product_Name)
      );
    } else if (selectedItem && selectedItem !== "All") {
      filtered = filtered.filter((item) =>
        item.Product_Name.includes(selectedItem)
      );
    }

    if (filters.Quality_Grade) {
      filtered = filtered.filter((item) =>
        item.Quality_Grade.includes(filters.Quality_Grade)
      );
    }
    if (filters.Harbour) {
      filtered = filtered.filter((item) =>
        item.Harbour.includes(filters.Harbour)
      );
    }
    if (filters.minPrice) {
      filtered = filtered.filter(
        (item) => item.Price_per_Kg >= parseFloat(filters.minPrice)
      );
    }
    if (filters.maxPrice) {
      filtered = filtered.filter(
        (item) => item.Price_per_Kg <= parseFloat(filters.maxPrice)
      );
    }
    if (filters.minWeight) {
      filtered = filtered.filter(
        (item) => item.Total_Available_Quantity >= parseFloat(filters.minWeight)
      );
    }
    if (filters.maxWeight) {
      filtered = filtered.filter(
        (item) => item.Total_Available_Quantity <= parseFloat(filters.maxWeight)
      );
    }

    filtered =
      filtered?.filter((item) =>
        item.Product_Name?.toLowerCase().includes(searchQuery.toLowerCase())
      ) || filtered;

    setFilteredData(filtered);
    setLoading(false); // Set loading to false immediately after filtering
  };

  // Trigger filterStockData when filters change
  useEffect(() => {
    filterStockData();
  }, [filters, selectedItem, stockData, searchQuery]);

  const carouselItems = [
    { img: AllFish, label: "All" },
    { img: yellowFinTuna, label: "Yellowfin Tuna" },
    { img: bigEyeTuna, label: "Bigeye Tuna" },
    { img: sailfish, label: "Sailfish" },
    { img: blackMarlin, label: "Black Marlin" },
    { img: swordFish, label: "Swordfish" },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8; // Number of items per page

  // Calculate total pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Get paginated data
  const paginatedData = filteredData?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const [showOutOfStockMessage, setShowOutOfStockMessage] = useState(false);

  return (
    <React.Fragment>
      <section className="section gaps bg-light" style={{ paddingTop: "80px" }}>
        <Container fluid>
          <Section link="Stocks" />
          <Row>
            <Col lg={3}>
              {/* <Topbar
                stocks={stockData}
                filters={filters}
                setFilters={setFilters}
                filterStockData={filterStockData} // Pass the function without calling it
              /> */}

              <Topbar
                stocks={stockData}
                filters={filters}
                setFilters={setFilters}
                filterStockData={filterStockData}
                showOutOfStockMessage={showOutOfStockMessage}
                setShowOutOfStockMessage={setShowOutOfStockMessage}
              />
            </Col>

            <Col lg={9}>
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "30vh",
                    borderRadius: "20px",
                    margin: "10px",
                  }}
                >
                  <InfinitySpin width="200" color="#00d1fc" />
                </div>
              ) : (
                <div className="mt-3 mb-4">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <h5 style={{ margin: 0 }}>Stocks</h5>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #ccc",
                        borderRadius: "20px",
                        padding: "5px 5px",
                        width: "250px",
                        background: "#fff",
                      }}
                    >
                      <FaSearch style={{ color: "#888", marginRight: "8px" }} />
                      <input
                        type="text"
                        placeholder="Search..."
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                          border: "none",
                          outline: "none",
                          width: "100%",
                          background: "transparent",
                        }}
                      />
                    </div>
                  </div>
                  {paginatedData.length === 0 ? (
                    <div className="no-result-container">
                      {!navigator.onLine ? (
                        <>
                          <Icon
                            path={mdiWifiOff}
                            size={4.6}
                            color="#777777"
                            style={{ marginRight: "8px" }}
                          />
                          <p>
                            You appear to be offline. Please check your internet
                            connection.
                          </p>
                        </>
                      ) : (
                        <>
                          <Icon
                            path={mdiMagnify}
                            size={4.6}
                            color="#777777"
                            style={{ marginRight: "8px" }}
                          />
                          <h2>No Results</h2>
                          <p>
                            We're sorry. We cannot find any matches for your
                            search term.
                          </p>
                        </>
                      )}
                    </div>
                  ) : (
                    <div>
                      <StockListPage
                        showOutOfStockMessage={showOutOfStockMessage}
                        stockData={paginatedData}
                      />
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Stocks;
